import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["positions"];
import { createElementObject, createPathComponent, extendContext } from '@react-leaflet/core';
import { Polygon as LeafletPolygon } from 'leaflet';
export var Polygon = createPathComponent(function createPolygon(_ref, ctx) {
  var positions = _ref.positions,
    options = _objectWithoutProperties(_ref, _excluded);
  var polygon = new LeafletPolygon(positions, options);
  return createElementObject(polygon, extendContext(ctx, {
    overlayContainer: polygon
  }));
}, function updatePolygon(layer, props, prevProps) {
  if (props.positions !== prevProps.positions) {
    layer.setLatLngs(props.positions);
  }
});